import { defaultSitemapObject } from "./model/DefaultSitemapObject";
import GlobalDispatchMethods from "../../context/globalDispatchMethods";
import { PageRecord } from "../recordDefinition.types";
import { Sitemap } from "./sitemapEntries";

/** The sitemap out of the initial state, or the default one when none is saved yet. */
export function adaptSitemap(read: PageRecord): PageRecord {
  const saved = read.sitemap as Sitemap | undefined;
  const source = saved?.Items?.length ? saved : defaultSitemapObject;

  return { sitemap: JSON.parse(JSON.stringify(source)) };
}

/** Sitemap's update takes the whole sitemap as its one attribute. */
export const toSitemapPayload = (record: PageRecord) => ({ sitemap: record.sitemap });

/** The navigation rebuilds from the saved sitemap, and the initial state is read again. */
export function afterSitemapSave(record: PageRecord, dispatch: unknown) {
  const globalDispatch = dispatch as (action: Record<string, unknown>) => void;

  globalDispatch({ type: GlobalDispatchMethods.SetSitemap, sitemap: record.sitemap });
  globalDispatch({ type: GlobalDispatchMethods.ResetInitialState });
}

export const sitemapValidators = {
  sitemap: (_: unknown, record: PageRecord) =>
    record.sitemapPendingEdit
      ? "Apply or cancel the changes in the properties panel before saving."
      : "",
};
